angular.module('unica_invitation_room.invitation_room_services', []);